import { yamadumiApi } from '../yamadumi-api'
import {
  GetLaborStackManagementTableFileUrlsReqParams,
  GetLaborStackManagementTableFileUrlsResObj,
  ReportOutputReq
} from '@gateway.Simulation'

export class YamadumiManagementGateWay {
  static getLaborStackManagementTableFileUrls = async (
    params: GetLaborStackManagementTableFileUrlsReqParams & ReportOutputReq
  ) => {
    return await yamadumiApi.get<GetLaborStackManagementTableFileUrlsResObj>(
      '/api/report/yamadumi-management',
      {
        ...params as unknown as Record<string, unknown>,
        totalCostFrom: params.totalCostFrom !== null && params.totalCostFrom !== undefined ? params.totalCostFrom * 1000000 : params.totalCostFrom,
        totalCostTo: params.totalCostTo !== null && params.totalCostTo !== undefined ? params.totalCostTo * 1000000 : params.totalCostTo,
        ourCompanyTotalCostFrom: params.ourCompanyTotalCostFrom !== null && params.ourCompanyTotalCostFrom !== undefined ? params.ourCompanyTotalCostFrom * 1000000 : params.ourCompanyTotalCostFrom,
        ourCompanyTotalCostTo: params.ourCompanyTotalCostTo !== null && params.ourCompanyTotalCostTo !== undefined ? params.ourCompanyTotalCostTo * 1000000 : params.ourCompanyTotalCostTo
      }
    )
  }
}
